import MapDraw from '../mapDraw';

export const resetMapControl = () => {
  MapDraw.map?.control.reset();
};
